import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "12.223",
      cy: "12",
      r: "6.064",
      stroke: "currentColor",
      "stroke-width": ".737"
    }, null, -1),
    _createElementVNode("ellipse", {
      stroke: "currentColor",
      "stroke-width": ".737",
      rx: "5.897",
      ry: "1.474",
      transform: "matrix(1 0 0 -1 12.223 12)"
    }, null, -1),
    _createElementVNode("ellipse", {
      cx: "12.223",
      cy: "12",
      stroke: "currentColor",
      "stroke-width": ".737",
      rx: "5.897",
      ry: "1.474",
      transform: "rotate(-90 12.223 12)"
    }, null, -1)
  ]))]))
}
export default { render: render }